import { defineComponent } from 'vue';
import Modal from './Modal.vue';
import VariationStep from './VariationStep.vue';
import AttributeStep from './AttributeStep.vue';
import ProjectStep from './ProjectStep.vue';
import StepList from './StepList.vue';
import Spinner from './Spinner.vue';
import { tradeAreaClient } from '../lib/client';
import { numWithDots } from '~/lib/utils';
import $ from 'jquery';
export default defineComponent({
    name: 'ProductConfigurator',
    components: {
        Modal,
        VariationStep,
        AttributeStep,
        ProjectStep,
        StepList,
        Spinner,
    },
    props: {
        product: {
            type: Object,
            required: true,
        },
        project: {
            type: Number,
            default: 0,
        },
    },
    emits: ['select', 'close'],
    data() {
        return {
            loadingVariations: false,
            productWithVariations: null,
            currentStep: 0,
            selectedVariation: null,
            selectedMods: [],
            selectedProject: null,
            selectedRoom: '',
            quantity: 1,
        };
    },
    computed: {
        width() {
            if (this.selectedVariation !== null &&
                this.selectedVariation.width !== '') {
                return `W. ${this.selectedVariation.width}`;
            }
            return '';
        },
        depth() {
            if (this.selectedVariation !== null &&
                this.selectedVariation.depth !== '') {
                return `D. ${this.selectedVariation.depth}`;
            }
            return '';
        },
        length() {
            if (this.selectedVariation !== null &&
                this.selectedVariation.length !== '') {
                return `L. ${this.selectedVariation.length}`;
            }
            return '';
        },
        minMaxPrice() {
            if (this.selectedVariation === null) {
                return {
                    min: Number(this.product.basePrice),
                    max: Number(this.product.maxPrice),
                };
            }
            const total = this.selectedMods.reduce((acc, curr) => {
                return acc + Number(curr.priceMod.priceMod);
            }, Number(this.selectedVariation.basePrice) * this.quantity);
            const res = {
                min: total,
                max: Number(this.selectedVariation.maxPrice),
            };
            if (this.selectedVariation.attributes.length > 0 &&
                this.selectedMods.length === this.selectedVariation.attributes.length) {
                res.max = res.min;
            }
            return res;
        },
        totalString() {
            if (this.minMaxPrice.max === this.minMaxPrice.min) {
                return `€ ${numWithDots(this.minMaxPrice.min)}`;
            }
            if (this.minMaxPrice.max === 0) {
                return `From € ${numWithDots(this.minMaxPrice.min)}`;
            }
            return (`From € ${numWithDots(this.minMaxPrice.min)} ` +
                `to € ${numWithDots(this.minMaxPrice.max)}`);
        },
        canNext() {
            // check for variation step
            if (this.steps.length > 1 && this.currentStep === 0 && this.hasVariations) {
                return this.selectedVariation !== null;
            }
            // check for attribute steps
            if (this.steps.length > 2 &&
                this.selectedVariation !== null &&
                this.currentStep < this.selectedVariation.attributes.length + 1) {
                // because mods step starts form 1
                return this.selectedMods[this.currentStep - 1] !== undefined;
            }
            if (this.isProjectStep && this.selectedProject !== null) {
                return true;
            }
            return false;
        },
        hasVariations() {
            return (this.productWithVariations !== null &&
                this.productWithVariations.variations.length > 0);
        },
        steps() {
            let steps = [];
            if (this.hasVariations) {
                steps.push('Model');
            }
            if (this.selectedVariation !== null) {
                steps = steps.concat(this.selectedVariation.attributes.map((attr) => attr.name));
            }
            steps.push('Room');
            return steps;
        },
        isProjectStep() {
            // project step is always the last step
            return this.currentStep === this.steps.length - 1;
        },
    },
    watch: {
        product() {
            this.currentStep = 0;
            this.selectedVariation = null;
            this.selectedMods = [];
            this.productWithVariations = null;
        },
    },
    async beforeMount() {
        this.loadingVariations = true;
        this.productWithVariations = await tradeAreaClient.getProduct(this.product.id);
        if (this.productWithVariations.variations.length === 0) {
            this.selectedVariation = this.productWithVariations;
        }
        this.loadingVariations = false;
    },
    mounted() {
        this.openModal();
        let maxHeight = $('.modal__content').outerHeight();
        if (maxHeight === undefined)
            return;
        $('.modal-step > div').css('max-height', maxHeight);
    },
    unmounted() {
        this.closeModal();
    },
    methods: {
        openModal() {
            const el = document.querySelector('#site-page');
            if (el)
                el.classList.add('modal-overlay');
            $('body').css('overflow', 'hidden');
        },
        closeModal() {
            const el = document.querySelector('#site-page');
            if (el)
                el.classList.remove('modal-overlay');
            $('body').css('overflow', 'auto');
        },
        nextStep() {
            if (this.isProjectStep && this.selectedProject !== null) {
                this.$emit('select', this.selectedProject);
            }
            else {
                this.currentStep++;
                console.log('Step:', this.currentStep);
            }
        },
        previousStep() {
            if (this.currentStep === 0) {
                this.$emit('close');
                this.closeModal();
            }
            else {
                this.currentStep--;
            }
            console.log('Step:', this.currentStep);
        },
        selectVariation(variation) {
            console.log('Variation:', variation);
            this.selectedVariation = variation;
            this.nextStep();
        },
        addMod(attr, material, priceMod) {
            const mod = {
                attribute: attr,
                priceMod: priceMod,
                materialCod: material.cod,
                material: material,
            };
            console.log(`Mod for ${attr.name}:`, mod);
            // because mods step starts from 1
            this.selectedMods[this.currentStep - 1] = mod;
        },
        selectProject(project, room) {
            console.log('Selected project:', project.id, room);
            this.selectedProject = project;
            this.selectedRoom = room;
            const selectedRoom = this.selectedProject.rooms.find((p) => p.name === room);
            if (selectedRoom === undefined || this.productWithVariations === null || this.selectedVariation === null)
                return;
            selectedRoom.products.push({
                parentSku: this.productWithVariations.sku,
                sku: this.selectedVariation.sku,
                mods: this.selectedMods,
                quantity: this.quantity,
            });
        },
    },
});
